import { getTradeCardApi, getTradeCradByIdapi } from "../components/constant/api";
import { myApi } from "./api";

export const tradeCradApi = myApi.injectEndpoints({
  endpoints: (builder) => ({
    getTradeCard: builder.query({
      query: () => ({
        url: getTradeCardApi,
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response?.data ?? [] : [];
      },
      providesTags: (_) => ["tradecard"],
    }),
    getTradeCardById: builder.query({
      query: (post) => ({
        url: getTradeCradByIdapi+"/"+post.id,
        method: "GET",
      }),
      transformResponse: (response, meta, arg) => {
        return response.status ? response?.data ?? [] : [];
      },
      providesTags: (_) => ["tradecard"],
    }),
  }),
});

export const {useGetTradeCardQuery,useGetTradeCardByIdQuery}=tradeCradApi